<div class="flex flex-col lg:flex-row h-full flex flex-col gap-2 z-0 relative p-2">

  <!-- Left Side: Form -->
  <div
  
  ngClass="{'lg:w-3/5': showTrips, 'w-full': !showTrips }"
  
  class="w-full h-full overflow-y-auto p-4 bg-white dark:bg-zinc-950">
    <div
      class="p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">


     <div class="flex justify-between items-center">
      <h1 class="heading">
        {{ invoiceId ? 'Edit' : 'Add' }}
      </h1>
      <div class="flex gap-2">
        <button (click)="showTrips = !showTrips" class="btn btn-secondary btn-sm">
          {{ showTrips ? 'Hide Trips' : 'Show Trips' }}
        </button>
      </div>
     </div>

      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <form [formGroup]="invoiceForm">
        <section class="grid gap-4 sm:grid-cols-2">
          <!-- CustomerRef -->
          <ng-container formGroupName="CustomerRef">
            <div class="space-y-1">
              <label class="subheading">Customer</label>
              <div>
                <ng-select formControlName="value" id="id" (change)="onChangeCustomer($event)"
                  [notFoundText]="'No record found'" placeholder="Select a customer" [clearable]="false"
                  [searchable]="true">
                  <ng-option value="" disabled>Select a customer</ng-option>
                  <ng-option *ngFor="let customer of customers" [value]="customer.Id">
                    {{ customer.DisplayName | titlecase }}
                  </ng-option>
                </ng-select>
              </div>

              <div *ngIf="submitted && invoiceForm.get('CustomerRef.value')?.errors">
                <p *ngIf="invoiceForm.get('CustomerRef.value')?.errors?.['required']" class="pt-1 text-red-600 text-xs">
                  Customer is required
                </p>
              </div>
            </div>
          </ng-container>

          <!-- Due Date -->
          <div class="space-y-1">
            <label class="subheading">
              Due Date
            </label>
            <div class="flex flex-1 gap-2">
              <div class="flex-1">
                <input type="text" name="time" id="time" formControlName="DueDate" [owlDateTime]="DueDate"
                  [owlDateTimeTrigger]="DueDate" [readOnly]="true" />
                <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange(invoiceForm.get('DueDate'))"
                  #DueDate></owl-date-time>
              </div>
            </div>
            <div *ngIf="submitted && form.DueDate.errors">
              <p *ngIf="form.DueDate.errors.required" class="pt-1 text-red-600 text-xs">
                Due date is required
              </p>
            </div>
          </div>
        </section>

        <h3 class="font-bold mt-2">
          Reference
        </h3>
        <hr class="my-1 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 sm:grid-cols-2" formGroupName="reference">
          <!-- ---reference -->
          <div class="flex-1 gap-2">
            <div class="space-y-1">
              <label class="subheading">
                Name
              </label>
              <div>
                <div>
                  <input formControlName="name" name="name" id="name" type="text" />
                </div>
              </div>
            </div>
            <div class="space-y-1">
              <label class="subheading">
                ID
              </label>
              <div>
                <div>
                  <input formControlName="id" name="id" id="id" type="text" />
                </div>
              </div>
            </div>
          </div>

        </section>



      </form>
      <h3 class="font-bold mt-4">
        Billing
      </h3>
      <hr class="my-1 mt-2 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2" [formGroup]="invoiceForm">
        <ng-container formGroupName="BillEmail">
          <!-- ---reference -->
          <div class="flex-1 gap-2">
            <div class="space-y-1">
              <label class="subheading">
                Email
              </label>
              <div>
                <div>
                  <input formControlName="Address" name="Address" id="Address" type="text" />
                </div>
                <div *ngIf="submitted && BillEmail.get('Address')?.errors">
                  <p *ngIf="BillEmail.get('Address')?.errors?.email" class="pt-1 text-red-600 text-xs">
                    Valid Email is required
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </section>

              <!-- Line Items -->
<div class="flex justify-between items-center">
  <h3 class="font-bold mt-2 text-gray-900 dark:text-gray-100">
    Line Items
  </h3>
  <div>
    <button *ngIf="lineItems && lineItems.length" (click)="clearAllLineItems()" class="btn btn-danger text-xs">
      Clear
    </button>
  </div>
</div>
<hr class="my-2 w-full border-t border-zinc-950/10 dark:border-white/20" />

<form [formGroup]="invoiceForm">
  <section *ngIf="lineItems">
    <div class="max-h-[28rem] overflow-y-auto overflow-x-auto rounded-t-md">
    <table class="min-w-full border border-gray-300 dark:border-gray-700 rounded-md bg-white dark:bg-zinc-900">
      <thead class="bg-gray-100 dark:bg-zinc-800">
        <tr class="text-gray-800 dark:text-gray-200">
          <th class="p-2 text-left">#</th>
          <th class="p-2 text-left">Type</th>
          <th class="p-2 text-left">Product/Service</th>
          <th class="p-2 text-left">Service Date</th>
          <th class="p-2 text-left">SKU</th>
          <th class="p-2 text-left">Description</th>
          <th class="p-2 text-left">Qty</th>
          <th class="p-2 text-left">Rate</th>
          <th class="p-2 text-left">Amount</th>
          <th class="p-2 text-center">Action</th>
        </tr>
      </thead>

      <tbody formArrayName="Line">
        <tr *ngFor="let item of lineItems.controls; let i = index" [formGroupName]="i"
          class="border-t border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-100 bg-white dark:bg-zinc-900">
          <td class="p-2 text-gray-500 dark:text-gray-400">{{ i + 1 }}</td>
          <td class="p-2 w-40">
            <select formControlName="DetailType"
              class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100">
              <option value="SalesItemLineDetail" disabled>Normal</option>
              <option value="DescriptionOnly" disabled>Description Only</option>
            </select>
          </td>
          <!-- Product/Service -->
          <td class="p-2">
            <ng-container formGroupName="SalesItemLineDetail">
              <ng-container formGroupName="ItemRef">
                <select formControlName="value" (change)="onSelectService($event)"
                  class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100">
                  <option value="" disabled>Select Service</option>
                  <option *ngFor="let product of productItems" [value]="product.Id">
                    {{ product.Name | titlecase }}
                  </option>
                </select>
              </ng-container>
            </ng-container>
          </td>

          <!-- Service Date -->
          <td class="p-2">
            <ng-container formGroupName="SalesItemLineDetail">
              <input formControlName="ServiceDate" type="text" [owlDateTime]="serviceDateLineItem" [owlDateTimeTrigger]="serviceDateLineItem" [readOnly]="true"
                class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" />
              <owl-date-time [pickerType]="'calendar'"
                (afterPickerClosed)="onDateChange(item.get('SalesItemLineDetail.ServiceDate'))"
                #serviceDateLineItem>
              </owl-date-time>
            </ng-container>
          </td>

          <!-- SKU -->
          <td class="p-2">
            <div [ariaReadOnly]="true"
              class="border rounded-md p-2 w-full h-full bg-gray-50 dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100">
              <span *ngIf="preProductItems">
                {{
                item.get('SalesItemLineDetail.ItemRef.value')?.value &&
                preProductItems[item.get('SalesItemLineDetail.ItemRef.value')?.value]?.Sku || '0'
                }}
              </span>
            </div>
          </td>

          <!-- Description -->
          <td class="p-2">
            <textarea formControlName="Description" placeholder="Description" type="text"
              class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" > </textarea>
            <div *ngIf="submitted && item.get('Description')?.errors">
              <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Description is required</p>
            </div>
          </td>

          <!-- Qty -->
          <td class="p-2">
            <ng-container formGroupName="SalesItemLineDetail">
              <input formControlName="Qty" placeholder="Qty" type="number" (input)="calculateAmount($event, i)"
                class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" />
              <div *ngIf="submitted && item.get('SalesItemLineDetail.Qty')?.errors">
                <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Qty is required</p>
              </div>
            </ng-container>
          </td>

          <!-- Rate -->
          <td class="p-2">
            <ng-container formGroupName="SalesItemLineDetail">
              <input formControlName="UnitPrice" placeholder="Rate" type="number" (input)="calculateAmount($event, i)"
                class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" />
              <div *ngIf="submitted && item.get('SalesItemLineDetail.UnitPrice')?.errors">
                <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Rate is required</p>
              </div>
            </ng-container>
          </td>

          <!-- Amount -->
          <td class="p-2">
            <input formControlName="Amount" [readOnly]="true" placeholder="Amount" type="number"
              class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" />
            <div *ngIf="submitted && item.get('Amount')?.errors">
                <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Amount is required</p>
            </div>
          </td>

          <!-- Remove -->
          <td class="p-2 text-center">
            <span (click)="removeLineItem(i)">
              <svg xmlns="http://www.w3.org/2000/svg"
                class="inline-block size-5 ml-2 text-red-500 hover:text-red-400 transition" viewBox="0 0 14 14">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  d="M1 3.5h12m-10.5 0h9v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-9h0Zm2 0V3a2.5 2.5 0 0 1 5 0v.5m-4 2V11m3-5.5V11" />
              </svg>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    </div>

    <!-- Trip summary for the line items above -->
    <div *ngIf="selectedTrips?.length"
      class="flex flex-wrap items-center justify-end gap-x-8 gap-y-2 rounded-b-md border border-t-0 border-gray-300 dark:border-gray-700 bg-zinc-50 dark:bg-zinc-900 px-4 py-2">
      <div class="flex items-center gap-2">
        <span class="text-sm-light">Trips</span>
        <span class="text-sm-dark font-semibold">{{ selectedTrips.length }}</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-sm-light">Total Amount</span>
        <span class="text-base font-semibold text-primary">${{ selectedTripsTotal | number:'1.2-2' }}</span>
      </div>
    </div>

    <h3 class="font-bold mt-16 text-gray-900 dark:text-gray-100">Add</h3>

    <table class="min-w-full mt-1 border border-gray-300 dark:border-gray-700 rounded-md bg-gray-50 dark:bg-zinc-900">
      <thead class="bg-gray-100 dark:bg-zinc-800">
        <tr class="text-gray-800 dark:text-gray-200">
          <th class="p-2 text-left">Type</th>
          <th class="p-2 text-left">Product/Service</th>
          <th class="p-2 text-left">Service Date</th>
          <th class="p-2 text-left">SKU</th>
          <th class="p-2 text-left">Description</th>
          <th class="p-2 text-left">Qty</th>
          <th class="p-2 text-left">Rate</th>
          <th class="p-2 text-left">Amount</th>
          <th class="p-2 text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr [formGroup]="invoiceItemForm"
          class="border-t border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-100">
          <td class="p-2 w-40">
            <select formControlName="DetailType" (change)="onSelectType($event)"
              class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100">
              <option value="SalesItemLineDetail">Normal</option>
              <option value="DescriptionOnly">Description Only</option>
            </select>
          </td>
          <!-- Product/Service -->
          <td class="p-2">
            <ng-container formGroupName="SalesItemLineDetail">
              <ng-container formGroupName="ItemRef">
                <select formControlName="value" (change)="onSelectService($event)"
                  class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100">
                  <option value="">Select Service</option>
                  <option *ngFor="let product of productItems" [value]="product.Id">
                    {{ product.Name | titlecase }}
                  </option>
                </select>
                <div *ngIf="lineItemFormSubmitted && invoiceItemForm.get('SalesItemLineDetail.ItemRef.value')?.errors">
                  <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Service is required</p>
                </div>
              </ng-container>
            </ng-container>
          </td>

          <!-- Service Date -->
          <td class="p-2">
            <ng-container formGroupName="SalesItemLineDetail">
              <div class="flex flex-1 gap-2">
                <div class="flex-1">
                  <input type="text" name="time" id="time" formControlName="ServiceDate" [owlDateTime]="serviceDate"
                    [owlDateTimeTrigger]="serviceDate" [readOnly]="true"
                    class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" />
                  <owl-date-time [pickerType]="'calendar'"
                    (afterPickerClosed)="onDateChange(invoiceItemForm.get('SalesItemLineDetail.ServiceDate'))"
                    #serviceDate></owl-date-time>
                </div>
              </div>
            </ng-container>
          </td>

          <!-- SKU -->
          <td class="p-2">
            <div [ariaReadOnly]="true"
              class="border rounded-md p-2 w-full h-full bg-gray-50 dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100">
              <span *ngIf="preProductItems">
                {{
                invoiceItemForm.get('SalesItemLineDetail.ItemRef.value')?.value &&
                preProductItems[invoiceItemForm.get('SalesItemLineDetail.ItemRef.value')?.value]?.Sku || '0'
                }}
              </span>
            </div>
          </td>

          <!-- Description -->
          <td class="p-2">
            <textarea formControlName="Description" placeholder="Description" type="text"
              class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" ></textarea>
            <div *ngIf="lineItemFormSubmitted && invoiceItemForm.get('Description')?.errors">
                <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Description is required</p>
            </div>
          </td>

          <!-- Qty -->
          <td class="p-2">
            <ng-container formGroupName="SalesItemLineDetail">
              <input formControlName="Qty" placeholder="Qty" type="number"
                class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" />
              <div *ngIf="lineItemFormSubmitted && invoiceItemForm.get('SalesItemLineDetail.Qty')?.errors">
                <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Qty is required</p>
              </div>
            </ng-container>
          </td>

          <!-- Rate -->
          <td class="p-2">
            <ng-container formGroupName="SalesItemLineDetail">
              <input formControlName="UnitPrice" placeholder="Rate" type="number"
                class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" />
              <div *ngIf="lineItemFormSubmitted && invoiceItemForm.get('SalesItemLineDetail.UnitPrice')?.errors">
                <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Rate is required</p>
              </div>
            </ng-container>
          </td>

          <!-- Amount -->
          <td class="p-2">
            <input formControlName="Amount" [readOnly]="true" placeholder="Amount" type="text"
              class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100" />
            <div *ngIf="lineItemFormSubmitted && invoiceItemForm.get('Amount')?.errors">
              <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Amount is required</p>
            </div>
          </td>

          <!-- Add -->
          <td class="p-2 text-center">
            <!-- <span (click)="addLineItem()">
              <svg xmlns="http://www.w3.org/2000/svg"
                class="inline-block size-5 ml-2 text-green-500 hover:text-green-400 transition" viewBox="0 0 24 24">
                <path fill="currentColor"
                  d="M12 21q-.425 0-.712-.288T11 20v-7H4q-.425 0-.712-.288T3 12t.288-.712T4 11h7V4q0-.425.288-.712T12 3t.713.288T13 4v7h7q.425 0 .713.288T21 12t-.288.713T20 13h-7v7q0 .425-.288.713T12 21" />
              </svg>
            </span> -->
            <button (click)="addLineItem()" type="button" class="btn btn-secondary">
              Add
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="submitted && invoiceForm.get('Line')?.errors" class="flex justify-end mt-2">
      <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Please add at least one Product/Service</p>
    </div>
  </section>
</form>



      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

      <section class="flex justify-end gap-4">
        <button (click)="onSave()" type="submit" class="btn btn-secondary">
          {{ invoiceId ? 'Update' : 'Create' }}
        </button>
      </section>

    </div>
  </div>

  <app-invoice-trips [ngClass]="{ 'hidden': !showTrips }" class="w-full lg:w-2/5 h-full flex flex-col border-l border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-950"
    [preFundingSources]="preFundingSource"
    [type]="'fundingsource'"
    [fundingSources]="fundingSourceList"
    (onSetGlobalLineItemType)="onSetGlobalLineItemType($event)"
    (onSelectTrips)="onSelectTrips($event)" 
    (viewTripDetails)="openTripDetailsModal($event)"
  ></app-invoice-trips>
</div>

<app-trip-detail-modal *ngIf="tripId" [tripId]="tripId" [source]="'trips'"
  (closeModal)="tripId = null"></app-trip-detail-modal>